import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../../../services/api";
import { useToast } from "../ToastContext";
import { useNavigate } from "react-router-dom";
// import { supabase } from '../lib/supabase';

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  signup: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  error: string;
  setError: (error: string) => void;
}
interface User {
  password: string;
  email: string;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const showToast = useToast();
  const navigate = useNavigate();

  const login = async (email: string, password: string) => {
    setIsLoading(true);
    try {
      const map = {
        password: password,
        email: email,
      };
      const response = await api.post("/User/authenticate", map);
      setIsLoading(false);
      if (response.status !== 200) {
        showToast(
          "error",
          "Erro ao efetuar o login. Por favor, tente novamente mais tarde."
        );
        return;
      }
      api.defaults.headers.Authorization = `Bearer ${response.data.token}`;
      localStorage.setItem("token", response.data.token);
      navigate("/consult");
    } catch (error) {
      showToast("error", "Erro ao efetuar o login.");
      console.error("Failed to create user:", error);
      setIsLoading(false);
    }
  };

  const signup = async (email: string, password: string) => {};

  const logout = async () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const value = {
    isAuthenticated,
    isLoading,
    login,
    signup,
    logout,
    error,
    setError,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
